<template>
  <div class="office-location">
    <div
      class="input-wrapper all-day-wrapper timing-wrapper office-loaction main-content"
      @click="show"
    >
      <div class="title-wrapper position-relative">
        <span class="ver-center">Office</span>
      </div>
      <div class="content-wrapper position-relative">
        <span class="ver-center custom-ver-center r-0 value-text">
          <span class="max-width-100 overflow-eclips">{{ selectedValue }}</span>
          <object
            class="right-icon"
            :data="rightArrow"
            type="image/svg+xml"
            v-if="
              officeLocation &&
                officeLocation.locationDetails &&
                selectedProviderId &&
                officeLocation.locationDetails[selectedProviderId] &&
                officeLocation.locationDetails[selectedProviderId].length > 1
            "
          ></object>
        </span>
      </div>
    </div>

    <!-- General options -->
    <transition name="slide-left">
      <office-location-vue v-if="display" :done="done" v-scroll-lock />
    </transition>
  </div>
</template>

<script>
import OfficeLocationVue from "../Expand/OfficeLocation.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  props: {
    clientOrOtherClicked: Boolean
  },
  data() {
    return {
      display: false // Weather the inner options should be shown
    };
  },
  methods: {
    ...mapMutations({
      setSecondLevelHeaderActive: "setSecondLevelHeaderActive"
    }),
    /**
     * Function to show the inner option
     */
    show() {
      if (
        this.officeLocation &&
        this.officeLocation.locationDetails &&
        this.selectedProviderId &&
        this.officeLocation.locationDetails[this.selectedProviderId] &&
        this.officeLocation.locationDetails[this.selectedProviderId].length > 1
      ) {
        this.display = true;
        this.setSecondLevelHeaderActive(true);
      }
    },
    /**
     * Function to hide the inner option once an option is selected or back button is clicked
     */
    done() {
      this.display = false;
      this.setSecondLevelHeaderActive(false);
    }
  },
  components: {
    OfficeLocationVue
  },
  computed: {
    ...mapGetters({
      officeLocation: "getOfficeLocation", // Gets all the details about the office location
      isOffice: "getIsOffice",
      getProvider: "getProvider" // Get details about the currently selected provider
    }),
    /**
     * Get the selected providerID, false is returned if data has still not been retrieved
     */
    selectedProviderId() {
      if (this.getProvider.list.length > 0) {
        return parseInt(
          this.getProvider.list[this.getProvider.selectedIndex].id
        );
      } else {
        return false;
      }
    },
    /**
     * Returns the selected office location
     */
    selectedValue() {
      if (this.selectedProviderId && this.officeLocation) {
        if (this.officeLocation.custom === false) {
          const selectedVal = this.officeLocation.locationDetails[
            this.selectedProviderId
          ][this.officeLocation.selectedIndex];
          return (
            selectedVal.line1 +
            " " +
            selectedVal.line2 +
            " " +
            selectedVal.city +
            " " +
            selectedVal.postal_code
          );
        } else {
          return this.officeLocation.customValue;
        }
      } else {
        return false;
      }
    },
    rightArrow() {
      return require("../../../../assets/svg/right-arrow.svg");
    }
  },
  watch: {
    /**
     * Weather the client or others is clicked
     */
    clientOrOtherClicked(value) {
      if (value) {
        this.done();
      }
    }
  }
};
</script>

<style scoped>
.custom-ver-center {
  text-align: right;
}

.content-wrapper {
  padding-right: 10px;
  width: calc(70% - 10px) !important;
}

.title-wrapper {
  width: 30%;
}
</style>
